import { truelyValueMap } from '../../constants/common';
import { BrokerTierEnum } from '../../shared/generated';
export var getBrokerApprovalStatusMap = function getBrokerApprovalStatusMap() {
  return {
    approved: {
      value: truelyValueMap.yes.value,
      label: 'Approved'
    },
    notApproved: {
      value: truelyValueMap.no.value,
      label: 'Not Approved'
    }
  };
};
export var getBrokerApprovalStatusList = function getBrokerApprovalStatusList() {
  return Object.values(getBrokerApprovalStatusMap());
};
export var getBrokerEntityApprovalStatusMap = function getBrokerEntityApprovalStatusMap() {
  return {
    approved: {
      value: truelyValueMap.yes.value,
      label: 'Approved'
    },
    notApproved: {
      value: truelyValueMap.no.value,
      label: 'Not Approved'
    }
  };
};
export var getBrokerEntityApprovalStatusList = function getBrokerEntityApprovalStatusList() {
  return Object.values(getBrokerEntityApprovalStatusMap());
};
export var getBrokerTobaSignedStatusMap = function getBrokerTobaSignedStatusMap() {
  return {
    signed: {
      value: truelyValueMap.yes.value,
      label: 'Signed'
    },
    notSigned: {
      value: truelyValueMap.no.value,
      label: 'Not Signed'
    }
  };
};
export var getBrokerTobaSignedStatusList = function getBrokerTobaSignedStatusList() {
  return Object.values(getBrokerTobaSignedStatusMap());
};
export var getBrokerActurisActivatedStatusMap = function getBrokerActurisActivatedStatusMap() {
  return {
    no: {
      value: truelyValueMap.no.value,
      label: 'To request'
    },
    process: {
      value: 'in_progress',
      label: 'Submitted to Acturis'
    },
    yes: {
      value: truelyValueMap.yes.value,
      label: 'Active'
    }
  };
};
export var getBrokerActurisActivatedStatusList = function getBrokerActurisActivatedStatusList() {
  return Object.values(getBrokerActurisActivatedStatusMap());
};
export var getBrokerTierStatusMap = function getBrokerTierStatusMap() {
  return {
    tier_1: {
      value: BrokerTierEnum.TIER_1,
      label: 'Tier1'
    },
    tier_2: {
      value: BrokerTierEnum.TIER_2,
      label: 'Tier2'
    },
    tier_3: {
      value: BrokerTierEnum.TIER_3,
      label: 'Tier3'
    },
    tier_4: {
      value: BrokerTierEnum.TIER_4,
      label: 'Tier4'
    }
  };
};
export var getBrokerTierStatusList = function getBrokerTierStatusList() {
  return Object.values(getBrokerTierStatusMap());
};
export var getBrokerTypeMap = function getBrokerTypeMap() {
  return {
    retailBroker: {
      value: 'retail_broker',
      label: 'Retail broker'
    },
    wholesaleBroker: {
      value: 'wholesale_broker',
      label: 'Wholesale broker'
    },
    partner: {
      value: 'partner',
      label: 'Partner'
    },
    brokerNetwork: {
      value: 'broker_network',
      label: 'Broker network'
    },
    others: {
      value: 'others',
      label: 'Others'
    }
  };
};
export var getBrokerTypeList = function getBrokerTypeList() {
  return Object.values(getBrokerTypeMap());
};